import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';

export default async function subscribeAdd({ client, config }: Context, params: CustomQuery): Promise<ApiResult> {
  const param = {
    email: params
  };
  const url = new URL('/mall/subscribes/add', config.api.url);
  const { data: res } = await client.post(url.href, param);
  return res;
}
